import styled from "styled-components";

export const EcoLabelImg = styled.img`
    inline-size: 32px;
    block-size: 32px;
`;
